import { useCallback, useContext, useMemo } from "react";
import { SharedDataContext } from "../layouts/FetchSharedData";

function useMessageTicket() {
  const { sharedData, setSharedData } = useContext(SharedDataContext);

  const user = useMemo(() => {
    return sharedData.user;
  }, []);

  const reduceUnreadMessage = useCallback(messageId => {
    setSharedData(cur => {
      cur.user.messages.list = cur.user.messages.list.filter(
        item => item.id !== messageId
      );
      cur.user.messages.count = cur.user.messages.list.length;

      return { ...cur };
    });
  }, []);

  const reduceUnreadTickets = useCallback(ticketId => {
    setSharedData(cur => {
      cur.user.tickets.list = cur.user.tickets.list.filter(
        item => item.id !== ticketId
      );
      cur.user.tickets.count = cur.user.tickets.list.length;

      return { ...cur };
    });
  }, []);

  const countUnread = useCallback(() => {
    if (!user) {
      return 0;
    }
    return user.messages.count + user.tickets.count;
  }, []);

  return {
    countUnreadMessages: user ? user.messages.count : 0,
    unreadMessages: user ? user.messages.list : [],
    countUnreadTickets: user ? user.tickets.count : 0,
    unreadTickets: user ? user.tickets.list : [],
    reduceUnreadMessage,
    countUnread,
    reduceUnreadTickets,
  };
}
export default useMessageTicket;
